import { useState, useEffect } from "react";
import { 
  subscribeToInventory, 
  addInventoryItem,
  updateInventoryItem,
  deleteInventoryItem,
  appendInventoryLog as appendLogSvc
} from "../services/inventoryService";

export function useInventory() {
  const [inventory, setInventory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let unsubscribe = () => {};

    try {
      setLoading(true);
      unsubscribe = subscribeToInventory((data, err) => {
        if (err) {
          setError("Failed to load inventory.");
          setLoading(false);
          return;
        }
        setInventory(data);
        setLoading(false);
      });
    } catch (err) {
      console.error(err);
      setError("Failed to initialize inventory subscription.");
      setLoading(false);
    }

    return () => unsubscribe();
  }, []);

  const handleAddInventoryItem = async (itemData) => {
    try {
      setError("");
      return await addInventoryItem(itemData);
    } catch (err) {
      console.error("Error adding inventory item:", err);
      setError(err.message || "Failed to add inventory item.");
      throw err;
    }
  };

  const handleUpdateInventoryItem = async (id, itemData) => {
    try {
      setError("");
      await updateInventoryItem(id, itemData);
    } catch (err) {
      console.error("Error updating inventory item:", err);
      setError(err.message || "Failed to update inventory item.");
      throw err;
    }
  };

  const handleDeleteInventoryItem = async (id) => {
    try {
      setError("");
      await deleteInventoryItem(id);
    } catch (err) {
      console.error("Error deleting inventory item:", err);
      setError(err.message || "Failed to delete inventory item.");
      throw err;
    }
  };

  const appendInventoryLog = async (id, logData) => {
    try {
      setError("");
      await appendLogSvc(id, logData);
    } catch (err) {
      console.error("Error appending inventory log:", err);
      setError(err.message || "Failed to append inventory log.");
      throw err;
    }
  };

  return {
    inventory,
    loading,
    error,
    setError,
    addInventoryItem: handleAddInventoryItem,
    updateInventoryItem: handleUpdateInventoryItem,
    deleteInventoryItem: handleDeleteInventoryItem,
    appendInventoryLog
  };
}
